<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    top="10vh"
    width="90%"
    :title="$l('form_label_choose_sample') || '已有展会样品选择'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    v-el-dialog-drag
    append-to-body
  >
    <PageTable
      ref="chooseSampleInner"
      :type="type"
      :expoInfoCode="expoInfoCode"
    />
    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button v-if="type" type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import PageTable from './index.vue'
export default {
  props: {
    visible: { type: Boolean, default: false },
    type: String,
    expoInfoCode: { type: String, default: '' },
    confirmOnClose: { type: Boolean, default: true },
  },
  components: {
    PageTable,
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseSampleInner.choiceData()
      if (!data) return

      this.$emit('confirm', data)
      if (this.confirmOnClose) this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
